import { Patient, Slot } from "@cur8/rich-entity";
import { useNav } from "@pomle/react-router-paths";
import { ReactComponent as EightCornerStarIcon } from "assets/eight-corner-star.svg";
import { DateTime } from "luxon";
import { useMemo } from "react";
import { paths } from "render/routes/paths";
import { Typography } from "render/ui/presentation/Typography";
import { BigButton } from "render/ui/trigger/BigButton";
import styles from "./styles.module.sass";
import { Trans } from "./trans";

interface BookingUpcomingStageProps {
  patient: Patient;
  slot: Slot;
}

export function BookingUpcomingStage({
  patient,
  slot,
}: BookingUpcomingStageProps) {
  const nav = {
    appointment: useNav(paths.appointment),
  };
  const time = useMemo(() => {
    const format = "HH:mm";
    const start = slot.startTime;
    const end = slot.endTime;

    return `${start.toFormat(format)} - ${end.toFormat(format)}`;
  }, [slot]);
  const date = useMemo(() => {
    const start = slot.startTime;

    const isDifferentYear = start.year !== DateTime.now().year;

    return start.toFormat(`d MMMM${isDifferentYear ? " yyyy" : ""}`);
  }, [slot]);

  return (
    <div className={styles.BookingUpcomingStage}>
      <Typography variant="title-large">
        <Trans.Greeting patient={patient} />
      </Typography>
      <BigButton onClick={nav.appointment.on({ slotId: slot.slotId })}>
        <div className={styles.button}>
          <EightCornerStarIcon />
          <div className={styles.text}>
            <Typography variant="title-small" color="subtle">
              <Trans.ScanBooked />
            </Typography>
            <Typography variant="paragraph-sub">
              {time} • {date}
            </Typography>
          </div>
        </div>
      </BigButton>
    </div>
  );
}
